import React from 'react';

export default function VolumeMuteIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-volume-mute"><path className="primary" d="M6.59 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.59l4.7-4.7A1 1 0 0 1 13 4v16a1 1 0 0 1-1.7.7L6.58 16z"/><path className="secondary" d="M17.09 12l-1.8-1.8a1 1 0 1 1 1.42-1.4l1.79 1.79 1.8-1.8a1 1 0 0 1 1.4 1.42L19.92 12l1.8 1.8a1 1 0 0 1-1.42 1.4l-1.79-1.79-1.8 1.8a1 1 0 0 1-1.4-1.42L17.08 12z"/></svg>
    </Tag>
  )
};
